export const AuthTimer = (clock, time, setTime) => {
    if (sessionStorage.getItem('token')) {
        if (clock.current === null && time > 0) {
            clock.current = setInterval(() => {
                setTime((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(clock.current);
                        sessionStorage.removeItem('token');
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
        const hour = String(Math.floor(time / 3600)).padStart(2, '0');
        const minute = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
        const second = String(time % 60).padStart(2, '0');
        const css = time > 15 ? 'success' : 'error';
        return ({
            time: time,
            clock: <div className={`clock ${css}`}>{`${hour}:${minute}:${second}`}</div>
        });
    } else {
        return (<></>)
    }
};

